import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import homepage from './home_assets/homeupper.svg';
import homepng from './home_assets/homepng.png';
import mobile from '../../assets/images/homepage/MobileTrade.png';

import './home_styles/homeupper.css';

export default function HomeUpper() {
  return (
    <>
    <div className='homeupper'>
      <Container>
        <Row className='align-items-center'>
          <Col lg={6} className='text-start home_up_up mt-3'>
            <div className="homeupper_left_head">
              <h2 className='homeupper_head1'>VIRTUAL START</h2>
              <h2 className='homeupper_head2'>IEO LAUNCHPAD</h2>
            </div>
            <div className="homeupper_left_para">
              <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt, vel?</span>
            </div>
            <div className="homeupper_left_btns mt-4 d-flex gap-4">
              <Button className="homeupper_left_btn1 w-100">SUPER START</Button>
              <Button className="homeupper_left_btn2 w-100">LOGIN</Button>
            </div>
          </Col>
          <Col lg={6} className='mt-3'>
           <div>
              <img src={mobile} alt="Mobile Image" className='img-fluid' />
           </div>
          </Col>
        </Row>
      </Container>
    </div>
    </>
  )
}
